import * as t from "io-ts";
export const createTokenTypes = ({ dateTime, }) => {
    const flespiTokenT = t.strict({
        token: t.string,
        expireAt: dateTime,
    });
    return { flespiTokenT };
};
export const { flespiTokenT } = createTokenTypes({
    dateTime: t.any,
});
//# sourceMappingURL=flespi-token.js.map